// @flow
/**
 * Created by Mike Chung on 2/13/18.
 */

import {connect} from "react-redux";
import type {StoreState} from "../../reducers/combinedReducers";
import type {SsoActionButtonDispatchProps, SsoActionButtonOwnProps, SsoActionButtonStateProps} from "../../components/sso/SsoActionButton";
import SsoActionButton from "../../components/sso/SsoActionButton";
import {ssoUserResendActivationAction} from "../../actions/sso/creators/ssoUserActionCreator";
import * as _ from "lodash";
import type {Caller} from "../../components/QueryPage";
import {extractCaller} from "../QueryPage";
import config from "../../config/config";
import {openSsoUserResendActivationEmailModalAction} from "../../actions/modal/creators/ssoUserResendActivationEmailActionCreator";

const mapStateToProps = (state: StoreState, ownProps: SsoActionButtonOwnProps): SsoActionButtonStateProps => {

    const isLoading = _.get(state, `ssoUserAction.resendActivation.${ownProps.ssoUid}.isLoading`, false);
    const disabled = isLoading ||
        _.get(state, `ssoUserAction.activateUser.${ownProps.ssoUid}.isLoading`, false) ;
    return {
        disabled: disabled,
        caller: extractCaller(state),
        isLoading,
        roleIds: state.loginUser.roleIds
    };
};

const mapDispatchToProps = (dispatch): SsoActionButtonDispatchProps => {
    return {
        onClickAction: (ssoUid: string, caller: Caller, roleIds: Array<string>) => {
            if (!_.includes(roleIds, config.superUserRole)) {

                dispatch(openSsoUserResendActivationEmailModalAction(ssoUid));
            } else {
                dispatch(ssoUserResendActivationAction(ssoUid, caller));
            }
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SsoActionButton);



// WEBPACK FOOTER //
// ./src/containers/sso/ResendActivationEmailButton.js